// Core types for the Scrum Poker app
export const UserRole = {
    PARTICIPANT: "participant",
    VISITOR: "visitor",
    FACILITATOR: "facilitator",
};
const USER_ROLES = Object.values(UserRole);
export const isUserRole = (value) => typeof value === "string" && USER_ROLES.includes(value);
export const MAX_NAME_LENGTH = 100;
